import { useSnackbar } from 'notistack';
import { ConversationMessageContentType } from 'src/@types/conversation';
import { useLocales } from 'src/locales';
import { convertVideo } from 'src/utils/ffmpeg';

export const useConvertMediaFile = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { translate } = useLocales();

  const checkFileToConvert = async (type: string, file: File) => {
    if (type !== ConversationMessageContentType.VIDEO) return file;
    const fileName = file?.name
      ? file.name?.split('.').slice(0, -1).join('.')
      : 'video';
    const newFileName = fileName + '.mp4';
    try {
      return await convertVideo(file, newFileName);
    } catch (error) {
      enqueueSnackbar(
        translate('shared.erros.error_whe_trying_to_convert_file', {
          message: file.name,
        }),
        { variant: 'error' },
      );
      throw error;
    }
  };

  return { checkFileToConvert };
};
